import { _t } from 'app/utils/i18n';
import React, { FunctionComponent } from 'react';
interface props {
  children: any;
  requiredApiCalls?: boolean[];
}

const ServerError: FunctionComponent<props> = ({
  children,
  requiredApiCalls,
}: any) => {
  return (
    <>
      {requiredApiCalls?.some((e: any) => e) ? (
        <>
          {React.Children.map(children, (child: any) => {
            return React.cloneElement(child, {
              className: 'server-error',
              'data-error-massage': _t(
                'basic:still_retrieve_data_from_database'
              ),
            });
          })}
        </>
      ) : (
        children
      )}
    </>
  );
};

export default ServerError;
